const isPlainObject = (value: unknown): value is Record<string, unknown> => {
  if (!value || typeof value !== 'object') return false;

  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
};

export const stripTypename = <T>(value: T): T => {
  if (Array.isArray(value)) {
    return value.map(stripTypename) as T;
  }

  if (!isPlainObject(value)) {
    return value;
  }

  return Object.fromEntries(
    Object.entries(value)
      .filter(([key]) => key !== '__typename')
      .map(([key, nestedValue]) => [key, stripTypename(nestedValue)]),
  ) as T;
};
